/**
 * Simple timeout utilities with automatic cleanup
 */

let timeouts: number[] = [];

export const safeTimeout = (callback: () => void, delay: number): void => {
  const id = setTimeout(() => {
    callback();
    const index = timeouts.indexOf(id as unknown as number);

    if (index > -1) {
      timeouts.splice(index, 1);
    }
  }, delay) as unknown as number;

  timeouts.push(id);
};

export const cleanupTimeouts = (): void => {
  timeouts.forEach((id) => clearTimeout(id));
  timeouts = [];
};
